import { z } from 'zod';

import { convertBytesToMegabytes, validateFileSize } from './helpers';

const validationSchema = z
  .object({
    note: z.string(),
    attachmentFile: z.any(z.instanceof(File)).refine(validateFileSize, fileList => ({
      message: `File size is ${convertBytesToMegabytes(
        fileList[0].size
      )}MB. Maximum allowed size is 100MB`,
    })),
    attachmentPhoto: z
      .any(z.instanceof(File))
      .refine(validateFileSize, fileList => ({
        message: `Photo size is ${convertBytesToMegabytes(
          fileList[0].size
        )}MB. Maximum allowed size is 100MB`,
      }))
      .optional(),
    attachmentTypeCode: z.string().refine(val => val?.length, {
      message: 'Required',
    }),
  })
  .refine(
    ({ attachmentFile, attachmentPhoto }) => attachmentFile?.length || attachmentPhoto?.length,
    {
      path: ['attachmentFile'],
      message: 'Please select an attachment',
    }
  )
  .refine(
    ({ attachmentFile, attachmentPhoto }) => {
      if (attachmentFile?.length && attachmentPhoto?.length) {
        return false;
      }

      return true;
    },
    {
      path: ['attachmentFile'],
      message: 'Not allowed to upload file and photo at the same time',
    }
  );

export default validationSchema;
